import { render, staticRenderFns } from "./StudentNotifications.vue?vue&type=template&id=9108d594"
import script from "./StudentNotifications.vue?vue&type=script&lang=js"
export * from "./StudentNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports